import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnualWheelTaskDeleted = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24.772,
	height: 22.959,
	viewBox: "0 0 22.00 22.959",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_13848",
			"data-name": "Rectangle 13848",
			width: 16.208,
			height: 15.488,
			transform: "translate(0)",
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeWidth: .8
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_7952",
		"data-name": "Group 7952",
		transform: "translate(-621 -544)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Rectangle_13850",
			"data-name": "Rectangle 13850",
			transform: "translate(622 547)",
			fill: "#ececf0",
			stroke: "#ececf0",
			strokeWidth: 1,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 19,
				height: 15,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 18,
				height: 14,
				fill: "none"
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_7951",
			"data-name": "Group 7951",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "Group_7942",
				"data-name": "Group 7942",
				transform: "translate(586.564 555.472)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_7941",
					"data-name": "Group 7941",
					transform: "translate(43 -4)",
					children: [
						/* @__PURE__ */ _jsx("circle", {
							id: "Ellipse_581",
							"data-name": "Ellipse 581",
							cx: 5.521,
							cy: 5.521,
							r: 5.521,
							transform: "translate(2.546 2.619)",
							fill: "#ececf0",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: .8
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_8743",
							"data-name": "Path 8743",
							d: "M55.514,4.334a3.68,3.68,0,0,0-3.044,5.749l5.113-5.112A3.665,3.665,0,0,0,55.514,4.334Z",
							transform: "translate(-47.446 0.126)",
							fill: "#fafafa",
							stroke: "#9a9a9a",
							strokeLinejoin: "round",
							strokeWidth: .8
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_8744",
							"data-name": "Path 8744",
							d: "M55.191,12.805A3.68,3.68,0,0,0,60.3,7.693Z",
							transform: "translate(-49.192 -1.62)",
							fill: "#fafafa",
							stroke: "#9a9a9a",
							strokeLinejoin: "round",
							strokeWidth: .8
						})
					]
				})
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_7946",
				"data-name": "Group 7946",
				transform: "translate(621 544)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_7947",
					"data-name": "Group 7947",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Path_8740",
							"data-name": "Path 8740",
							d: "M20.5,10V2.5h-4",
							fill: "none",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_8741",
							"data-name": "Path 8741",
							d: "M4.5,2.5H.5v16h9",
							fill: "none",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_13841",
							"data-name": "Rectangle 13841",
							width: 3,
							height: 4,
							transform: "translate(4.5 0.5)",
							fill: "#ececf0",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_8746",
							"data-name": "Path 8746",
							d: "M0,0H3V4H0Z",
							transform: "translate(13.5 0.5)",
							fill: "#ececf0",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("line", {
							id: "Line_662",
							"data-name": "Line 662",
							x2: 6,
							transform: "translate(7.5 2.5)",
							fill: "none",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("line", {
							id: "Line_663",
							"data-name": "Line 663",
							x2: 20,
							transform: "translate(0.5 7.5)",
							fill: "none",
							stroke: "#9a9a9a",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						})
					]
				})
			})]
		})]
	})]
});
export default SvgAnnualWheelTaskDeleted;
